module.exports = __webpack_public_path__ + "static/img/14000757.652b5e81.png";